import { Box, Image, Text } from "@chakra-ui/react";
import React from "react";
import styles from "./experiential.module.css";
import Notes from "../../atoms/icons/notes.svg";

import Edit from "../../atoms/icons/edit.svg";
import Trash from "../../atoms/icons/trash.svg";
import Download from "../../atoms/icons/import.svg";
import Calculator from "../../atoms/icons/calculator.svg";
import { downloadUrl } from "../../../utils/common-utils";
import Assistant from "../ai-tutor/Assistant/Assistant";
import { deletePost } from "../../../api/wall";
import { useNavigate } from "@remix-run/react";
import { useState, useEffect } from "react";
import useStateRef from "react-usestateref";
import wall_images from "../../../utils/wall/wall-imges";
// import ImageModal from "../../atoms/ImageModal";
import { renderContent } from "../../../utils/TutorConstants";
import pkg from "@inrscr/coschool-ui-components";
import { ExperientialComponentStyles } from "./experientialComponentStyles";

export default function ExperientialBody({
  expData,
  isBackClicked,
  userDescription,
  postItem = {},
  handleEdit,
  handleDeleteCallback
}) {
  const navigate = useNavigate();
  const { ImageModal } = pkg;
  const [imagesList, setImagesList, imagesListRef] = useStateRef([]);
  const [attachementsList, setAttachementsList, attachementsListRef] =
  useStateRef([]);
  const [backClicked, setBackClicked, backClickedRef] =
  useStateRef(isBackClicked);
  // const [displayPost, setDisplayPost] = useState(true);
  const [isImageOpen, setIsImageOpen] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);
  const [postItemImageClick, setPostItemImageClick, postItemImageClickRef] =
  useStateRef(false);

  const handleDelete = async () => {
    const { success, data } = await deletePost(postItem?.id);
    if (success) {
      setBackClicked(false);
    }
    handleDeleteCallback();
  };

  const onEdit = () => {
    handleEdit();
    setBackClicked(false);
    // setDisplayPost(false);
  };

  useEffect(() => {
    setBackClicked(isBackClicked);
  }, [isBackClicked]);

  useEffect(() => {
    filterAttachements();
  }, [expData]);

  const filterAttachements = () => {
    let images = [];
    let attachements = [];
    expData?.activityInfo?.attachments?.map((item) => {
      if (item.mimeType.includes("image")) {
        images.push(item);
      } else if (
      item.mimeType.includes("doc") ||
      item.mimeType.includes("docx") ||
      item.mimeType.includes("msword") ||
      item.mimeType.includes("ppt") ||
      item.mimeType.includes("powerpoint") ||
      item.mimeType.includes("pdf") ||
      item.mimeType.includes("xlsx") ||
      item.mimeType.includes("xls") ||
      item.mimeType.includes("txt"))
      {
        attachements.push(item);
      }
    });

    setImagesList(images);
    setAttachementsList(attachements);
  };

  const formatFileName = (fileName) => {
    if (!fileName) return "";
    const length = fileName.length;
    if (length <= 10) return fileName; // If filename is less than or equal to 10 characters, show it as is
    return `${fileName.slice(0, 5)}...${fileName.slice(length - 5)}`;
  };

  const openImage = (index) => {
    setImageIndex(index);
    setIsImageOpen(true);
  };
  const handleClose = () => {
    setIsImageOpen(false);
  };

  return (
    <Box sx={ExperientialComponentStyles()?.experientialBodyContainer}>
      <Box sx={ExperientialComponentStyles()?.experientialBodyContentContainer}>
        <Text sx={ExperientialComponentStyles()?.experientialBodyContentTitle}>
          {renderContent(expData?.activityInfo?.name || "")}
        </Text>
        <Box
          sx={ExperientialComponentStyles()?.experientialDescriptionContainer}>

          <Text sx={ExperientialComponentStyles()?.experientialDescriptionWord}>
            Description:
          </Text>
          <Text
            sx={
            ExperientialComponentStyles()?.experientialBodyDescriptionContent
            }>

            {renderContent(expData?.activityInfo?.description || "")}
          </Text>
        </Box>
        <Box
          sx={ExperientialComponentStyles()?.experientialBodyImagesContainer}>

          <Box
            sx={ExperientialComponentStyles()?.experientialBodyImagesContent}>

            {imagesListRef.current &&
            imagesListRef.current.length > 0 &&
            imagesListRef.current.map((item, index) =>
            <Image
              sx={ExperientialComponentStyles()?.experientialBodyImage}
              key={index}
              src={item?.url}
              onClick={() => {
                openImage(index);
              }}>
            </Image>
            )}
          </Box>
        </Box>
      </Box>
      {attachementsListRef.current?.length > 0 &&
      <Box
        sx={ExperientialComponentStyles()?.experientialBodyDownloadContainer}>

          <Text
          fontFamily={"Poppins, Text-lg/Regular"}
          fontWeight={400}
          fontSize={"14px"}
          lineHeight={"21px"}
          marginBottom={"8px"}
          textColor={"#21146D"}>

            Download the reference material for detailed instruction and sample
            references.
          </Text>
          <div className={styles["option-container"]}>
            {attachementsListRef.current?.map((item, index) => {
            return (
              <div
                className={styles["download-box"]}
                onClick={() => {
                  downloadUrl(item?.url, item?.fileName);
                }}>

                  <Image
                  cursor={"pointer"}
                  w={"24px"}
                  h={"24px"}
                  src={Notes}>
                </Image>
                  <Text
                  fontFamily={"Poppins, Text-lg/Regular"}
                  fontWeight={400}
                  cursor={"pointer"}
                  fontSize={"14px"}
                  lineHeight={"21px"}
                  marginBottom={"8px"}
                  textColor={"#21146D"}
                  // whiteSpace={"nowrap"}
                  // overflow={"hidden"}
                  // textOverflow={"ellipsis"}
                  // flexGrow={1}
                >
                    {formatFileName(item?.fileName)}
                  </Text>
                  <Image
                  cursor={"pointer"}
                  w={"24px"}
                  h={"24px"}
                  src={Download}>
                </Image>
                </div>);

          })}
          </div>
        </Box>
      }

      {backClickedRef.current &&
      <div
        style={{
          backgroundColor: "#FFBFB7",
          width: "98%",
          borderTopLeftRadius: "4px",
          borderTopRightRadius: "16px",
          borderBottomLeftRadius: "16px",
          borderBottomRightRadius: "16px",
          marginTop: "16px",
          padding: "16px",
          marginBottom: "16px"
        }}>

          {/* <Text
           fontFamily={"Poppins, Text-lg/Semibold"}
           fontWeight={600}
           fontSize={"18px"}
           lineHeight={"27px"}
           marginBottom={"12px"}
           textColor={"#362F8C"}
          >
           {expData?.activityInfo?.name || ""}
          </Text> */}
          <div style={{ display: "flex" }}>
            {postItem?.attachments.map((item, index) =>
          <Image
            cursor={"pointer"}
            w={"48px"}
            h={"48px"}
            src={
            item?.fileName.includes(".pdf") ?
            wall_images.pdf :
            item?.fileName.includes(".ppt") ||
            item.fileName.includes(".pptx") ?
            wall_images.ppt :
            item?.fileName.includes(".jpg") ||
            item?.fileName.includes(".png") ||
            item?.fileName.includes(".jpeg") ||
            item?.fileName.includes(".bmp") ||
            item?.fileName.includes(".webp") ?
            item?.url :
            wall_images.doc
            }
            onClick={() => {
              if (
              item?.fileName.includes(".jpg") ||
              item?.fileName.includes(".png") ||
              item?.fileName.includes(".jpeg") ||
              item?.fileName.includes(".bmp") ||
              item?.fileName.includes(".webp"))
              {
                setPostItemImageClick(true);
                openImage(index);
              } else {
                downloadUrl(item?.url, item?.fileName);
              }
            }}
            borderRadius={"8px"}>
          </Image>
          )}

            {/* <Image cursor={"pointer"} w={"48px"} h={"48px"} src={Pdf}></Image> */}
            <Text
            fontFamily={"Poppins, Text-lg/Regular"}
            fontWeight={400}
            fontSize={"12px"}
            lineHeight={"18px"}
            marginBottom={"12px"}
            textColor={"#362F8C"}
            marginLeft={"12px"}>

              {renderContent(postItem?.content || postItem?.postBody || "")}
            </Text>
          </div>
          <div
          style={{
            width: "100%",
            display: "flex",
            height: "100%",
            justifyContent: "flex-end"
            // position:"absolute",
            // bottom:"0",
            // right:"0",
            // zIndex:"10"
          }}>

            <div
            style={{
              width: "40px",
              height: "40px",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
              marginRight: "-40px",
              marginBottom: "-30px",
              backgroundColor: "#fff",
              padding: "12px",
              borderRadius: "4px",
              display: "flex",
              gap: "16px",
              alignItems: "center"
            }}>

              <Image
              cursor={"pointer"}
              w={"20px"}
              h={"20px"}
              src={Edit}
              onClick={onEdit}>
            </Image>
              {/* <Image
                 cursor={"pointer"}
                 w={"20px"}
                 h={"20px"}
                 src={Trash}
                 onClick={handleDelete}
               ></Image> */}
            </div>
          </div>
        </div>
      }

      {isImageOpen &&
      <div style={{ background: "blue" }}>
          <ImageModal
          image={
          postItemImageClickRef?.current ?
          postItem?.attachments?.[imageIndex]?.url :
          imagesListRef?.current?.[imageIndex]?.url
          }
          isOpen={isImageOpen}
          onClose={handleClose} />

        </div>
      }
    </Box>);

}